export default "__VITE_ASSET__CIyoE09$__"